import { Component, inject } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngxs/store';
import { DscrState } from '@app/app/store/dscr/dscr.state';
import { CamelToSentencePipe } from '@app/app/pipes/camel-to-sentence.pipe';
import { DscrProductStatusIconDirective } from '../../dscr-product-status-icon.directive';

@Component({
  selector: 'app-dscr-finances',
  imports: [
    CurrencyPipe,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    CommonModule,
    CamelToSentencePipe,
    DscrProductStatusIconDirective,
    RouterLink
  ],
  templateUrl: './dscr-finances.component.html',
  styleUrl: './dscr-finances.component.scss'
})
export class DscrFinancesComponent {
  private _router = inject(Router);
  private _store = inject(Store);
  public dscrProducts = this._store.selectSignal(DscrState.dscrByProduct);
  public dscrGlobalSummary = this._store.selectSignal(DscrState.globalDscrSummary);
  public globalDscrLabels = ['globalCashflow', 'globalDebtService', 'globalDscr'];

  navigateToDeal(dealId: number): void {
    this._router.navigateByUrl(`deal/${dealId}`);
  }
}
